import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';
import { ErpCamposIntegracao } from 'px-business-components';

const hasCamposAdicionaisErpSankhyaNorsil = camposIntegracao => camposIntegracao.natureza !== null;

const hasCamposAdicionaisErpArtLatex = camposIntegracao => camposIntegracao.natureza !== null;

export const hasCamposAdicionaisErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return hasCamposAdicionaisErpSankhyaNorsil(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return hasCamposAdicionaisErpArtLatex(camposIntegracao);
  }
  return false;
};

const validateCamposErpSankhyaNorsil = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'A natureza é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpArtLatex = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'A natureza é obrigatória'];
  }
  return [true, null];
};


export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return validateCamposErpSankhyaNorsil(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return validateCamposErpArtLatex(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return {
      natureza: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.NATUREZA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return {
      natureza: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.NATUREZA.key,
      ),
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_NORSIL.key) {
    return {
      natureza: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA_ART_LATEX.key) {
    return {
      natureza: null,
    };
  }
  return {};
};
